import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  patients: [],
};

const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    addPatient: (state, action) => {
      state.patients.push(action.payload);
    },
    removePatient: (state, action) => {
      const patientToRemove = action.payload;
      state.selectedPatient = state.selectedPatient.filter(
        (patient) => patient.name !== patientToRemove.name
      );
    },
    clearPatient: (state) => {
      state.patients = []
    },

    addPreviousPageForEditPatient: (state, action) => {
      state.previousPageForEditPatient = action.payload;
    },
    clearPreviousPageForEditPatient: (state, _action) => {
      state.previousPageForEditPatient = undefined;
    },
  },
});

export const { addPatient, removePatient, clearPatient, addPreviousPageForEditPatient, clearPreviousPageForEditPatient } = patientSlice.actions;
export const patientReducer = patientSlice.reducer;
